<template>
    <div>
        <div class="my-account--container" :class="{'drop-down-open': !isClosed}" v-click-outside="closeMenu" @click="toggleMenu">
            <img height="40" width="40" src="@/assets/images/decoration/my-account.svg"/>
            <div class="my-account--dropdown">
                <p v-if="isDesktop">{{ $t('DASHBOARD_MY_ACCOUNT') }}</p>
                <img v-if="isClosed" class="arrow-margin" src="@/assets/images/decoration/my-account-arrow-down.svg">
                <img v-else class="arrow-margin" src="@/assets/images/decoration/my-account-arrow-up.svg">
            </div>
        </div>
        <div v-show="!isClosed" class="my-account--menu">
            <div class="my-account--menu-style">
            <p class="space-route" v-for="(item, index) in menuItems" :key="index">
                <router-link
                    :to="{ name: item.route }"
                    v-on:click.native="$emit('menu-clicked')"
                    :class="{ 'selected-route': isActiveRoute(item) }"
                    class="my-account-route">
                    <span v-text="item.label"></span>
                </router-link>
            </p></div>
            <div  v-if="isFlowerBondHolder" class="my-account--menu-bondholder">
            <router-link target="_blank" :to="{ name: 'flowerbond'}">
                <div class="bondHolderButton">
                    <img class="bondHolderButton__icon" :src="flowerBondIcon" alt="Flower Bond Holder"/>
                    <p class="bondHolderButton__text" v-text="$t('NAV_BOND_HOLDER')"></p>
                </div>
            </router-link>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import NavigationLinks from '@/config/NavigationLinks';

export default {
    name: 'MyAccount',
    data() {
        return {
            flowerBondIcon: require('@/assets/images/decoration/icon-bondholder-nav.svg'),
            isClosed: true,
            window: {
                width: 0,
                desktopLowerBreakpoint: 1024,
                mobileBreakpoint: 768,
            },
        };
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    computed: {
        ...mapGetters({
            isUserLoggedIn: 'auth/isUserLoggedIn',
            isFlowerBondHolder: 'account/getFlowerBondStatus',
        }),
        menuItems() {
            const allMenuItems = NavigationLinks.items;
            const enabled = allMenuItems.filter((item) => { return typeof item.myAccount !== 'undefined' && item.myAccount.enabled; });
            const myAccountItems = enabled.map((item) => Object.assign(item.myAccount, item));
            const sortedItems = myAccountItems.sort((prevItem, nextItem) => prevItem.order - nextItem.order);
            return sortedItems;
        },
        isDesktop() {
            const isDesktop = this.window.width >= this.window.desktopLowerBreakpoint;
            return isDesktop;
        },
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
        },
        isPage(pageArr) {
            if (this.$route.name.includes('account-confirmation')) return true;
            const pageRoot = this.$route.name.split('.')[0];
            return pageArr.find(page => pageRoot === page);
        },
        toggleMenu() {
            this.isClosed = !this.isClosed;
        },
        closeMenu() {
            this.isClosed = true;
        },
        isActiveRoute(item) {
            return this.$route.name === item.route;
        },
    },
};
</script>

<style lang="scss">
    .my-account {
        &--container {
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 48px;
            margin-left: 8px;
            border-radius: 136px;
            padding: 0px 12px;
            cursor: pointer;
            background-color: #FFFFFF;
            transition: background-color .1s linear;
            -moz-transition: background-color .1s linear;
            -webkit-transition: background-color .1s linear;
        }
        &--container:hover {
            transition: background-color .1s linear;
            -moz-transition: background-color .1s linear;
            -webkit-transition: background-color .1s linear;
            background-color: #ECE9E8;
        }
        &--dropdown {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
        }
        &--menu {
            width: 260px;
            background-color: #ffffff;
            position: absolute;
            z-index: 9999;
            right: 20px;
            text-align: left;
            box-shadow: 0px 8px 40px 0px #00000033;
        }
        &--menu-style {
            padding: 20px;
            padding-bottom: 0px;
        }
        &--menu-bondholder {
            background-color: #ECE9E8;
            height: 60px;
            padding-left: 20px;
            display: flex;
            align-items: center;
        }
    }

    .drop-down-open {
        background-color: #ECE9E8;
    }

    .my-account-route {
        padding: 10px 24px;
        border-radius: 136px;
        cursor: pointer;
        background-color: #ffffff;
        transition: background-color .1s linear;
        -moz-transition: background-color .1s linear;
        -webkit-transition: background-color .1s linear;
    }

    .my-account-route:hover {
        transition: background-color .1s linear;
        -moz-transition: background-color .1s linear;
        -webkit-transition: background-color .1s linear;
        background-color: #ECE9E8;
    }

    .selected-route {
        background-color: #ECE9E8;
    }

    .space-route {
        margin-top: 16px;
        margin-bottom: 16px;
    }

    @media (min-width: 768px) {
        .my-account {
            &--dropdown {
                margin-left: -10px;
            }
        }
    }
    @media (min-width: 1024px) {
        .my-account {
            &--container {
                padding: 0px 16px 0px 12px;
            }
            &--dropdown {
                margin-left: 2px;
            }
        }
    }

    .arrow-margin {
        margin-left: 4px;
    }
</style>
